import React, { useCallback } from "react"
import { Confirm } from "./Confirm"
import { useDispatch } from "react-redux"
import { nameToSlug } from "../../../Models/API/AppTemplateModel"
import { hasValue } from "../../../Models/Client/FetchState"
import { Loader } from "dash-styled"
import { closeModal } from "../../../Actions/Client/ModalActions"
import { useAppState } from "../../../Hooks/useReduxState"
import { useAppTemplate } from "../../../Hooks/useAppTemplate"
import {
    endOnboarding,
    endOnboardingGoToReview,
    endOnboardingGoToUpload
} from "../../../Actions/API/AppTemplate/Interface/TemplateInstantiateActions"

export const AskIfReviewJobOutput = () => {
    const instanceID = useAppState(
        state => state.api.interface.templateInstantiate?.instanceID
    )
    const templateSlug = useAppState(state => {
        const onboarding = state.api.interface.templateInstantiate

        return onboarding === null
            ? undefined
            : nameToSlug(onboarding.templateIdentifier)
    })

    const templateData = useAppTemplate(instanceID)
    const dispatch = useDispatch()
    const handleClose = useCallback(() => {
        dispatch(endOnboarding())
        dispatch(closeModal())
    }, [dispatch])
    const handleClickYes = useCallback(() => {
        if (templateSlug === undefined) {
            return
        }

        dispatch(endOnboardingGoToReview())
    }, [dispatch, templateSlug])

    const handleClickNo = useCallback(() => {
        if (templateSlug === undefined) {
            return
        }

        dispatch(endOnboardingGoToUpload())
    }, [dispatch, templateSlug])

    return hasValue(templateData) ? (
        <Confirm
            title="Your results are ready"
            description={`We're done with your ${templateData.value.metadata.name.toLowerCase()} data point`}
            yesLabel="Review Output"
            noLabel="Upload more data"
            onClickYes={handleClickYes}
            onClickNo={handleClickNo}
            onClose={handleClose}
        />
    ) : (
        <Loader />
    )
}
